'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = ['M48 409.1l0 4.7c0 27.8 22.5 50.3 50.3 50.3 6.8 0 13.5-1.4 19.7-4-3.9-12.9-6-26.5-6-40.6 0-48.5 25-93.6 66.1-119.3l61.9-38.7 0-117.4-64 0 0 110.3c0 27.6-14.2 53.2-37.6 67.8L73.8 362.5C57.8 372.5 48 390.1 48 409.1zM176 64l0 32 64 0 0-48-48 0c-8.8 0-16 7.2-16 16zm32 345.1l0 4.7c0 27.8 22.5 50.3 50.3 50.3 9.9 0 19.6-2.9 27.9-8.4l110.2-73.5c22.3-14.8 35.6-39.8 35.6-66.6l0-171.5-96 0 0 110.3c0 27.6-14.2 53.2-37.6 67.8l-64.6 40.4c-16.1 10-25.8 27.6-25.8 46.6zM336 64l0 32 96 0 0-32c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z', 'M240 0l0 48-48 0c-8.8 0-16 7.2-16 16l0 32 64 0 0 48-64 0 0 110.3c0 27.6-14.2 53.2-37.6 67.8L73.8 362.5C57.8 372.5 48 390.1 48 409.1l0 4.7c0 27.8 22.5 50.3 50.3 50.3 6.8 0 13.5-1.4 19.7-4 4.7 15.6 12.1 30.1 21.6 42.9-12.9 6-26.9 9.1-41.3 9.1-54.3 0-98.3-44-98.3-98.3l0-4.7c0-35.5 18.3-68.5 48.4-87.3L113 281.4c9.4-5.8 15-16.1 15-27.1L128 64c0-35.3 28.7-64 64-64l48 0zm96 144l0 110.3c0 27.6-14.2 53.2-37.6 67.8l-64.6 40.4c-16.1 10-25.8 27.6-25.8 46.6l0 4.7c0 27.8 22.5 50.3 50.3 50.3 9.9 0 19.6-2.9 27.9-8.4l110.2-73.5c22.3-14.8 35.6-39.8 35.6-66.6l0-171.5-96 0zm0-48l96 0 0-32c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 32zM480 64l0 251.5c0 42.8-21.4 82.8-57 106.5L312.8 495.5c-16.1 10.8-35.1 16.5-54.5 16.5-54.3 0-98.3-44-98.3-98.3l0-4.7c0-35.5 18.3-68.5 48.4-87.3L273 281.4c9.4-5.8 15-16.1 15-27.1L288 64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;